<top-navig [displayLogo]="false" title="Restaurant"></top-navig>
<div class="info">
    <div class="container head" [@zoomIn]="true">
        <div *ngIf="pdv?.image" class="row image" oncontextmenu="return false;" [ngClass]="{loading:!loadAvatar}">
            <img loading [src]="pdv.image|absolutePath:'img'" style="position: relative" width="100%" (load)="loadAvatar=true">
        </div>
        <div class="row comment" *ngIf="pdv?.comment">
            <div class="col-md-12">
                <h3 class="heading">Le restaurant :</h3>
                <hr class="half_space">
                <div [innerHtml]="pdv?.comment" class="comment cont-zone"></div>
            </div>
        </div>
        <div class="row" *ngIf="pdv?.openingtext">
            <div class="col-md-12">
                <h3 class="heading">Horaires d'ouverture</h3>
                <hr class="half_space">
                <div *ngIf="pdv?.openingtext" [innerHtml]="pdv?.openingtext" class="comment cont-zone"></div>
            </div>
        </div>

        <div class="row livraison">
            <div class="col-md-12">
                <h3 class="heading">Zones de livraison</h3>
                <hr class="half_space">
                <div class="cont-zone">
                    <div class="row content" *ngFor="let zone of authorizedCities;">
                        <div class="col-md-8 left">
                            {{zone.name}} {{zone.postalCode}}
                        </div>
                        <div class="col-md-4 right">
                            <span class="cir">{{zone.amountMiniDelivery}} €</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12">
                <h3 class="heading">Contact :</h3>
                <hr class="half_space">
                <div class="contact-info cont-zone fadeInUp animated">
                    <div class="footer_column contact">
                        <p> <img src="assets/images/restaurant.svg" style="margin-right: 6px;" width="19px" [alt]="pdv?.name">
                            {{pdv?.name}}
                        </p>
                        <p class="address">
                            <i class="flaticon-pin"></i>
                            <a #maplink href="#" target="_blank"> {{pdv?.address}}</a>
                        </p>
                        <p class="phone">
                            <i class="flaticon-phone-on-circle"></i>
                            <a href="tel:{{pdv?.phone}}">{{pdv?.phone}}</a>
                        </p>
                        <p class="email" *ngIf="pdv?.emailContact">
                            <i class="flaticon-arroba"></i>
                            <a href="mailto:{{pdv?.emailContact}}">
                                <span>
                                    {{pdv?.emailContact}}
                                </span>
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div id="map"></div>